let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bffjE")).then(() => parcelRequire('2LTTf'));